import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { Differentiator } from '../components/Differentiator';
import { HowItWorks } from '../components/HowItWorks';
import { ComparisonTable } from '../components/ComparisonTable';
import { PricingSection } from '../components/PricingSection';
import { CalculatorSection } from '../components/CalculatorSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-brand-100 selection:text-brand-900" data-id="element-427">
      <Navbar data-id="element-428" />
      <main data-id="element-429">
        <Hero data-id="element-430" />
        <ProblemSection data-id="element-431" />
        <Differentiator data-id="element-432" />
        <HowItWorks data-id="element-433" />
        <ComparisonTable data-id="element-434" />
        <PricingSection data-id="element-435" />
        <CalculatorSection data-id="element-436" />
        <FinalCTA data-id="element-437" />
      </main>
      <Footer data-id="element-438" />
    </div>;
}